import { createUseStyles } from 'react-jss';
export default createUseStyles({
  container: {
    borderRadius: '50%',
    overflow: 'hidden'
  },
  image: {
    height: '100%',
    width: '100%'
  },
  small: {
    height: 32,
    width: 32
  },
  regular: {
    height: 40,
    width: 40
  },
  medium: {
    height: 50,
    width: 50
  },
  large: {
    height: 60,
    width: 60
  }
});